/** 是否為一級代理 */
export function isFirstLevelAgent(member) {
  return member?.agentLevel === 'FIRST_LEVEL_AGENT';
}

/** 是否顯示「輸入邀請碼」入口（上級為平台根且非代理、且在後補期限內） */
export function canShowBackfillInviter(member) {
  return Boolean(member?.canBackfillInviterCode) && !isFirstLevelAgent(member);
}
